import store from '@/store/index'
import io from 'socket.io-client'

let socket = null
export function getPushSocketInstance () {
  socket = store.getters['getPushSocketInstance']
  if (socket === null || socket.id === 0) {
    const storeIdx = localStorage.getItem('restaurantIdx')
    const connectOption = {
      path: '/socket',
      withCredentials: true,
      transports: ['websocket', 'polling'],
      query: { restaurantIdx: storeIdx }
    }
    socket = io(process.env.VUE_APP_SOCKET_SERVER, connectOption)
  }
  return socket
}
